import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  avatar: {
    width: ({ nTamanho, lMostrarDoisAvatares, nTamanhoAvatarDuplo }) => {
      if (lMostrarDoisAvatares && nTamanhoAvatarDuplo) return nTamanhoAvatarDuplo
      return lMostrarDoisAvatares ? 42 : nTamanho
    },
    height: ({ nTamanho, lMostrarDoisAvatares, nTamanhoAvatarDuplo }) => {
      if (lMostrarDoisAvatares && nTamanhoAvatarDuplo) return nTamanhoAvatarDuplo
      return lMostrarDoisAvatares ? 42 : nTamanho
    },
    border: `1px solid ${theme.palette.neutral200}`,
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      transform: "scale(1.075)",
    },
  },
  avatarSecundario: {
    width: ({ nTamanhoAvatarDuplo }) => nTamanhoAvatarDuplo || 42,
    height: ({ nTamanhoAvatarDuplo }) => nTamanhoAvatarDuplo || 42,
    border: `2px solid ${theme.palette.background100}`,
    transition: "all 0.2s ease-in-out",
    zIndex: 1,
    position: "absolute",
    bottom: 0,
    right: 0,
    WebkitUserDrag: "none",
  },
  containerDoisAvatares: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    position: "relative",
    width: ({ nTamanhoContainer }) => nTamanhoContainer || 64,
    height: ({ nTamanhoContainer }) => nTamanhoContainer || 64,
    marginRight: 6,
    "&:hover $avatar": {
      transform: "scale(1.075)",
    },
    "&:hover $avatarSecundario": {
      transform: "scale(1.075)",
    },
  },
}))

export default useStyles
